export const blogQueryKeys = {
  publishedPosts: ["blog-posts", "published"] as const,
  post: (slug: string) => ["blog-post", slug] as const,
};
